import { ErrorsView, Property, ResultSetError } from '@interfaces/results/results-class-library';
import { elementAt } from 'rxjs/operators';

let errors: ErrorsView[] = [];
let resultSetErrors: ResultSetError[] = [];
const errorCollection = {};

export function setResultSetErrors(value) {
  resultSetErrors = value;
}

export function getResultSetErrors() {
  return resultSetErrors;
}

export function setErrors(value) {
  errors = value;
}

export function getErrorCollection() {
  return errorCollection;
}

export function logError(
  errorView: ErrorsView,
  property: any,
  balance: string,
  period: number,
  code: string,
  othermnemonic: string,
  type: number,
  resultsetId: number,
  resultsetMnemonic: string
) {
  errors.push(errorView);

  const prop: Property = new Property();
  if (type === 1) {
    prop.mnemonic = property.Mnemonic;
    prop.period = period;
    prop.error_code = code;
    prop.othermnemonic = othermnemonic;
  } else {
    prop.period = period;
    prop.error_code = code;
  }
  const resultSetError: ResultSetError = {
    type,
    resultset_id: resultsetId,
    mnemonic: resultsetMnemonic,
    balance,
    errors: [errorView],
    property: prop,
  };
  resultSetErrors.push(resultSetError);

  if (!errorCollection[resultSetError.mnemonic]) {
    errorCollection[resultSetError.mnemonic] = [];
  }

  errorCollection[resultSetError.mnemonic].push(resultSetError);
}

export function errorAlreadyLogged(
  errorView: ErrorsView,
  ResultSet: any,
  property: any,
  balance: string,
  period: number,
  code: string,
  othermnemonic: string,
  type: number
) {
  if (errorCollection[ResultSet.Mnemonic]) {
    let resError: ResultSetError = errorCollection[ResultSet.Mnemonic].find(
      ele =>
        ele.mnemonic === ResultSet.Mnemonic &&
        ele.balance === balance &&
        ele.type === type &&
        ele.resultset_id === ResultSet.resultset_id &&
        ele.property.period === period &&
        ele.property.error_code === code &&
        ele.property.mnemonic == property.Mnemonic &&
        ele.property.othermnemonic === othermnemonic
    );
    if (resError) {
      if (resError.errors.find(ele => ele.row === errorView.row && ele.column === errorView.column && ele.message === errorView.message)) {
        return true;
      }
    }
  }
  return false;
}
